import React from 'react';
import {
  CondensedHeader,
  Gutter,
  Layout,
  LayoutItem,
  useApi,
  Well,
} from '@axiom/ui';
import type { Candidate } from '@axiom/validation';

import { CandidateApi } from '../../api/candidate-api';

export type CandidatePerformanceSummaryProps = {
  name?: string;
  candidateId: Candidate['id'];
};

export const CandidatePerformanceSummary = ({
  name = 'CANDIDATE_PERFORMANCE_SUMMARY',
  candidateId,
}: CandidatePerformanceSummaryProps) => {
  const [{ data: summary }] = useApi(
    CandidateApi.readCandidateReputation({ candidateId })
  );

  return (
    <Well name={name}>
      <Layout>
        <LayoutItem fluid>
          <CondensedHeader>Average Client Recommend Score</CondensedHeader>
        </LayoutItem>
        <LayoutItem name="RECOMMEND_SCORE_VALUE">
          {summary?.averageClientRecommendScore ?? '--'}
        </LayoutItem>
      </Layout>
      <Gutter bottom="8px" />
      <Layout>
        <LayoutItem fluid>
          <CondensedHeader>Number of Responses</CondensedHeader>
        </LayoutItem>
        <LayoutItem name="RESPONSES_VALUE">
          {summary?.numberOfRespondents ?? 0}
        </LayoutItem>
      </Layout>
      <Gutter bottom="8px" />
      <Layout>
        <LayoutItem fluid>
          <CondensedHeader>% Meets Expectations</CondensedHeader>
        </LayoutItem>
        <LayoutItem name="MEET_EXPECTATION_VALUE">
          {summary?.percentMetExpectations
            ? `${summary.percentMetExpectations}%`
            : '--'}
        </LayoutItem>
      </Layout>
      <Gutter bottom="8px" />
      <Layout>
        <LayoutItem fluid>
          <CondensedHeader>Number of Talent-Related Roll Offs</CondensedHeader>
        </LayoutItem>
        <LayoutItem name="ROLL_OFFS_VALUE">
          {summary?.talentRelatedRollOffs ?? 0}
        </LayoutItem>
      </Layout>
    </Well>
  );
};
